var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container services" },
    [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v(_vm._s(_vm.trans("services.title_" + _vm.$root.network)))
      ]),
      _vm._v(" "),
      _vm.is_ie
        ? _c(
            "my-carousel",
            {
              ref: "services_carousel",
              attrs: {
                "per-page-custom": [
                  [0, 1],
                  [768, 2],
                  [991, 2],
                  [1190, 3]
                ]
              }
            },
            _vm._l(_vm.config, function(section, section_index) {
              return _c(
                "div",
                {
                  key: section_index,
                  staticClass: "carousel-card mx-auto px-1 text-center"
                },
                [
                  _c("div", { staticClass: "img-service" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "/img/services/" +
                          _vm.trans("services." + section_index + ".img") +
                          ".jpg",
                        alt: _vm.trans("services." + section_index + ".title"),
                        width: "477",
                        height: "256"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-3" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("services." + section_index + ".title")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.trans("services." + section_index + ".text"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-network btn-md",
                        attrs: {
                          href: _vm.trans("services." + section_index + ".href")
                        }
                      },
                      [_vm._v(_vm._s(_vm.trans("services.button")))]
                    )
                  ])
                ]
              )
            }),
            0
          )
        : _c(
            "my-carousel",
            {
              directives: [
                {
                  name: "waypoint",
                  rawName: "v-waypoint",
                  value: {
                    active: true,
                    callback: _vm.toggleAnimated,
                    options: _vm.intersectionOptions
                  },
                  expression:
                    "{ active: true, callback: toggleAnimated, options: intersectionOptions }"
                }
              ],
              ref: "services_carousel",
              attrs: {
                "per-page-custom": [
                  [0, 1],
                  [768, 2],
                  [991, 2],
                  [1190, 3]
                ]
              },
              on: { "page-change": _vm.animateSlide }
            },
            _vm._l(_vm.config, function(section, section_index) {
              return (section == 1) | ((section == 2) & _vm.$root.is_mobile2)
                ? _c("slide", { key: section_index }, [
                    _c(
                      "div",
                      {
                        staticClass: "carousel-card mx-auto px-1 text-center",
                        on: {
                          mouseenter: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.mouseEnter(section_index)
                          },
                          mouseleave: function($event) {
                            $event.stopPropagation()
                            return _vm.mouseLeave(section_index)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "img-service" }, [
                          _c("img", {
                            attrs: {
                              src:
                                "/img/services/" +
                                _vm.trans(
                                  "services." + section_index + ".img"
                                ) +
                                ".jpg",
                              alt: _vm.trans(
                                "services." + section_index + ".title"
                              ),
                              width: "477",
                              height: "256"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-3" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "services." + section_index + ".title"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.trans("services." + section_index + ".text")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-network btn-md",
                              attrs: {
                                href: _vm.trans(
                                  "services." + section_index + ".href"
                                ),
                                target: _vm.trans(
                                  "services." + section_index + ".target"
                                )
                                  ? _vm.trans(
                                      "services." + section_index + ".target"
                                    )
                                  : null
                              }
                            },
                            [_vm._v(_vm._s(_vm.trans("services.button")))]
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            }),
            1
          ),
      _vm._v(" "),
      !_vm.$root.is_mobile2 & (_vm.config.sell == 2) & (_vm.config.rent == 2)
        ? _c(
            "my-carousel",
            {
              directives: [
                {
                  name: "waypoint",
                  rawName: "v-waypoint",
                  value: {
                    active: true,
                    callback: _vm.toggleAnimated,
                    options: _vm.intersectionOptions
                  },
                  expression:
                    "{ active: true, callback: toggleAnimated, options: intersectionOptions }"
                }
              ],
              ref: "services_carousel",
              staticClass: "sell-rent",
              attrs: {
                "per-page-custom": [
                  [0, 1],
                  [768, 2],
                  [991, 2],
                  [1190, 3]
                ]
              },
              on: { "page-change": _vm.animateSlide }
            },
            _vm._l(_vm.config, function(section, section_index) {
              return section == 2
                ? _c("slide", { key: section_index }, [
                    _c(
                      "div",
                      { staticClass: "carousel-card px-1 text-center" },
                      [
                        _c("div", { staticClass: "img-service" }, [
                          _c("img", {
                            attrs: {
                              src:
                                "/img/services/" +
                                _vm.trans(
                                  "services." + section_index + ".img"
                                ) +
                                ".jpg",
                              alt: _vm.trans(
                                "services." + section_index + ".title"
                              ),
                              width: "477",
                              height: "256"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-3" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "services." + section_index + ".title"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.trans("services." + section_index + ".text")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-network btn-md",
                              attrs: {
                                target: "blank",
                                href: _vm.trans(
                                  "services." + section_index + ".href"
                                )
                              }
                            },
                            [_vm._v(_vm._s(_vm.trans("services.button")))]
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }